import { CartItem, StoreSeller, PaymentMethod, PaymentMethodLabel } from '../models';
import { formatCurrency } from './currency';

interface PaymentEntry {
  paymentMethod: PaymentMethod;
  amountPaid: number;
  installments?: 1 | 2;
}

export function buildWhatsAppUrl(
  seller: StoreSeller,
  items: CartItem[],
  orderId?: number,
  paymentEntries?: PaymentEntry[],
  customerName?: string,
  customerPhone?: string,
  observation?: string
): string {
  const lines = items.map((i) => {
    const sku = i.variantSku ? ` [${i.variantSku}]` : '';
    const giftTag = i.isGift ? ' (presente)' : '';
    return `• ${i.productName}${sku} (${i.variantLabel}) x${i.quantity} — R$ ${formatCurrency((i.promotionalPrice ?? i.price) * i.quantity)}${giftTag}`;
  });

  const total = formatCurrency(
    items.reduce((sum, i) => sum + (i.promotionalPrice ?? i.price) * i.quantity, 0)
  );

  const messageParts: string[] = [];

  if (customerName && customerPhone) {
    messageParts.push(`*Cliente:* ${customerName}`, `*WhatsApp:* ${customerPhone}`, '');
  }

  messageParts.push('Olá! Gostaria de fazer um pedido:', '');

  if (orderId && orderId > 0) {
    messageParts.push(`*Pedido #${orderId}*`, '');
  }

  messageParts.push(...lines);
  messageParts.push('', `*Total: R$ ${total}*`);

  if (paymentEntries && paymentEntries.length > 0) {
    const paymentLines = paymentEntries.map((e) => {
      let label = PaymentMethodLabel[e.paymentMethod];
      if (e.paymentMethod === PaymentMethod.CreditCard && e.installments === 2) {
        const installmentValue = e.amountPaid / 2;
        label += ` — 2x sem juros (2x de R$ ${formatCurrency(installmentValue)})`;
      }
      return `• ${label}: R$ ${formatCurrency(e.amountPaid)}`;
    });
    messageParts.push('', '*Formas de pagamento:*', ...paymentLines);
  }

  const giftItems = items.filter((i) => i.isGift);
  if (giftItems.length > 0) {
    messageParts.push('', `*Presente:* ${giftItems.length} de ${items.length} ${giftItems.length === 1 ? 'item é' : 'itens são'} presente`);
  }

  if (observation) {
    messageParts.push('', `*Observação:* ${observation}`);
  }

  const message = messageParts.join('\n');
  const phone = seller.whatsAppPhone.startsWith("55") ?
  seller.whatsAppPhone.replace(/\D/g, '') : "55" + seller.whatsAppPhone.replace(/\D/g, '');
  return `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
}
